import Textarea from "./Textarea"
import Expression from './Expression'
import Input from './Input'
import RedPanda from './images/redpanda.png'

import axios from 'axios'
import { useForm } from 'react-hook-form'
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import config from '../config.json'
import { Trans, useTranslation } from "react-i18next"

interface FormData {
  name: string
  email: string
  message: string
}

interface FooterProps {
  id?: string
  className?: string
  defaultMessage: string
}

const Footer = ({ id, className, defaultMessage }: FooterProps) => {

  const { t } = useTranslation()
  const [formHasSumitted, setFormHasSumitted] = useState(false)
  const [formError, setFormError] = useState("")
  const [loading, setLoading] = useState(false)

  const { setValue, reset, register, handleSubmit, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      name: '',
      email: '',
      message: ''
    }
  })

  useEffect(() => {
    setValue("message", defaultMessage)
  }, [defaultMessage, setValue])

  const onSubmit = (data: FormData) => {
    setLoading(true)
    axios.post(`${config.API_ENDPOINT}/messages/email`, {
      from: config.CONTACT_FROM,
      to: config.CONTACT_TO,
      title: "Kontaktformular",
      content: `
        Nachricht erhalten von: ${data.name} \n\n
        Email addresse: ${data.email} \n\n
        ${data.message}
      `
    }, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        'X_API_KEY': `b2dvZ29ndGI2${config.REACT_APP_API_KEY}dGI2bW9vb29vYg==`,
        'X_APP': config.REACT_APP_APP,
        'X_REGION': config.REACT_APP_REGION
      }
    })
      .then(res => {
        res.data.ok ? setFormError("") : setFormError("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder senden Sie mir eine Email. Danke!")
        reset()
      })
      .catch(err => {
        setFormError("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder senden Sie mir eine Email. Danke!")
        setFormHasSumitted(true)
      })
      .finally(() => {
        setFormHasSumitted(true)
        setLoading(false)
      })
  }

  return (
    /* Footer */
    <div id={id} className={`${className} container mx-auto`}>

      <div className="flex flex-col md:flex-row justify-center bg-white my-8 px-4">

        <div className='basis-1/2 lg:basis-1/3'>
          <Expression
            className="text-2xl">
              { t("footer.lookingForward") }
          </Expression>
          <img src={RedPanda} alt="Red Panda" className="w-48 h-48" />
        </div>

        <div className="px-8 lg:basis-1/3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col">
              <Input errors={errors["name"]} register={register("name", { required: t("footer.pleaseEnterYourName") })} type="text" id="name" placeholder={t("footer.yourName")} />
              <Input errors={errors["email"]} register={register("email", { required: t("footer.pleaseEnterYourEmail") })} type="email" id="email" placeholder={t("footer.yourEmail")} />
              <Textarea errors={errors["message"]} register={register("message", { required: t("footer.pleaseEnterYourMessage") })} id="message" message={t("footer.yourMessage")} />
              <div>
                <button disabled={loading} type="submit" className="mt-4 bg-gradient-to-br from-amber-400 to-amber-500 shadow-md hover:scale-105 duration-300 text-white py-2 px-4">
                  {
                    loading ?
                      <svg aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                      </svg>
                      : t("contact.send")
                  }
                </button>
              </div>
            </div>
          </form>

          {
            /* Form Submit Success */
            formHasSumitted &&
            (
              formError ?
                <div className="mt-4">
                  <p className="text-red-500">{formError}</p>
                </div>
                :
                <div className="mt-4">
                  <p className="text-green-500">{ t("message.success") }</p>
                </div>
            )
          }



          <div className="mt-4">
            <Trans i18nKey="contact.direct">
              Oder direkt anfragen per <a className="underline hover:no-underline" href="mailto:zhang@mingquan.ch">E-Mail</a>.
            </Trans>
          </div>
        </div>
      </div>

      <div>


        <div className="flex flex-wrap justify-center p-4 mb-8 mt-24">
          <div className="basis-full text-center py-8">
            <Link to="/datenschutz" className="underline hover:no-underline mr-4">{ t("privacy.title") }</Link>
            <Link to="/impressum" className="underline hover:no-underline">{ t("impressum.title") }</Link>
          </div>
          <p>© 2024 Ming's Mandarin</p>
        </div>
      </div>

    </div>
  )
}

export default Footer